import { create } from 'zustand'

const useSliderStore = create((set) => ({
  // Initialize all sliders as false
  openSliders: {
    points: false,
    assists: false,
    rebounds: false,
  },

  // One action to rule them all
  toggle: (type) => 
    set((state) => ({
      openSliders: {
        ...state.openSliders,
        [type]: !state.openSliders[type]
      }
    })),

  // Specific close helper
  close: (type) => 
    set((state) => ({
      openSliders: {
        ...state.openSliders,
        [type]: false
      }
    })),
}))



export default useSliderStore;